/* eslint-disable react/no-unescaped-entities */
import React, { useState } from 'react';
import {
  Collapse,
  Box,
  Button,
  UnorderedList,
  ListItem,
} from '@chakra-ui/react';

const TermsConditions = () => {
  const [show, setShow] = useState(false);

  const handleToggle = () => setShow(!show);

  return (
    <Box>
      <Button
        variant="ghost"
        onClick={handleToggle}
        color="blue.500"
        textDecoration="underline"
        style={{ cursor: 'pointer' }}
      >
        {show ? 'Nascondi Termini e Condizioni' : 'Mostra Termini e Condizioni'}
      </Button>
      <Collapse in={show}>
        <Box mt={4} bg="#f8f8f8" p={4}>
          <UnorderedList>
            <ListItem>
              <strong>Premessa:</strong> L'adesione all'Associazione di
              Promozione Sociale “CIL - Creatività in Libertà APS” (di seguito
              “Associazione”) è regolata dal presente documento, che si integra
              con lo Statuto dell'Associazione e le norme di legge applicabili.
            </ListItem>
            <ListItem>
              <strong>Finalità dell'Associazione:</strong> L'Associazione si
              propone di perseguire finalità civiche, solidaristiche e di
              utilità sociale, promuovendo attività culturali, artistiche,
              educative e ricreative in conformità allo Statuto e al Codice del
              Terzo Settore.
            </ListItem>
            <ListItem>
              <strong>Modalità di Tesseramento:</strong> La richiesta di
              adesione deve essere presentata tramite apposito modulo,
              disponibile online o presso la sede dell'Associazione. La
              richiesta è subordinata alla delibera del Consiglio Direttivo, che
              si riserva il diritto di accettare o rifiutare l'ammissione nel
              rispetto delle disposizioni statutarie.
            </ListItem>
            <ListItem>
              <strong>Diritti dei Soci:</strong> I soci hanno diritto a
              partecipare alle attività e agli eventi organizzati
              dall'Associazione. Votare in Assemblea secondo le modalità
              previste dallo Statuto. Proporre iniziative e progetti in linea
              con le finalità associative.
            </ListItem>
            <ListItem>
              <strong>Doveri dei Soci:</strong> I soci si impegnano a rispettare
              lo Statuto, i regolamenti interni e le delibere degli organi
              associativi. Contribuire alla realizzazione delle attività
              associative. Versare la quota associativa annuale entro i termini
              previsti.
            </ListItem>
            <ListItem>
              <strong>Perdita della Qualifica di Socio:</strong> La qualifica di
              socio si perde per recesso volontario, comunicato per iscritto al
              Consiglio Direttivo. Mancato pagamento della quota associativa
              entro il termine stabilito. Violazione grave delle norme
              statutarie o regolamentari.
            </ListItem>
            <ListItem>
              <strong>Trattamento dei Dati Personali:</strong> I dati personali
              forniti dai soci saranno trattati in conformità al Regolamento UE
              2016/679 (GDPR) e alla normativa nazionale vigente. Informazioni
              dettagliate sono contenute nell'Informativa sulla Privacy
              disponibile presso la sede dell'Associazione e sul sito ufficiale.
            </ListItem>
            <ListItem>
              <strong>Modifiche ai Termini:</strong> L'Associazione si riserva
              il diritto di modificare i presenti Termini e Condizioni, previa
              comunicazione ai soci tramite i canali ufficiali.
            </ListItem>
            <ListItem>
              <strong>Legge Applicabile e Foro Competente:</strong> Le presenti
              condizioni sono regolate dalla legge italiana. Per qualsiasi
              controversia sarà competente il foro di Torino.
            </ListItem>
          </UnorderedList>
        </Box>
      </Collapse>
    </Box>
  );
};

export default TermsConditions;
